/**
 * Расширенный GraphQL клиент с дополнительными возможностями
 *
 * Этот файл создан на основе автогенерируемого apps/frontend-new/src/gql/gen/index.ts
 * и добавляет дополнительные возможности для работы с GraphQL запросами.
 */

// @ts-nocheck
import {
    type ClientOptions,
    createClient as createClientOriginal,
    type FieldsSelection,
    linkTypeMap,
} from '@/core/graphql/genql/runtime'
import type { RetryPolicy } from '@/core/request'
import type { Mutation, MutationGenqlSelection, Query, QueryGenqlSelection, } from './gen/schema'
import types from './gen/types'

// Реэкспорт всех типов из схемы
export * from './gen/schema'

const typeMap = linkTypeMap(types as any)

/**
 * Расширенные опции для запросов
 */
export interface RequestOptions {
    /** Таймаут запроса в миллисекундах */
    timeout?: number
    /** Количество повторных попыток при ошибке */
    retries?: number
    /** Политика повторных попыток */
    retryPolicy?: RetryPolicy
    /** Имя операции для отладки */
    operationName?: string
}

/**
 * Расширенный интерфейс клиента с поддержкой дополнительных опций
 */
export interface ClientExtended {
    /**
     * Выполнить GraphQL query
     * @param request - GraphQL запрос
     * @param options - Дополнительные опции (timeout, retries)
     */
    query<R extends QueryGenqlSelection>(
        request: R & { __name?: string },
        options?: RequestOptions,
    ): Promise<FieldsSelection<Query, R>>

    /**
     * Выполнить GraphQL mutation
     * @param request - GraphQL мутация
     * @param options - Дополнительные опции (timeout, retries)
     */
    mutation<R extends MutationGenqlSelection>(
        request: R & { __name?: string },
        options?: RequestOptions,
    ): Promise<FieldsSelection<Mutation, R>>
}

/**
 * Создать расширенный GraphQL клиент
 *
 * @example
 * ```typescript
 * const client = createClientExtended({
 *   url: 'http://localhost:4000/graphql'
 * });
 *
 * // С таймаутом и повторными попытками
 * const result = await client.query({
 *   users: {
 *     id: true,
 *     name: true
 *   }
 * }, {
 *   timeout: 5000,
 *   retries: 3
 * });
 * ```
 */
export const createClientExtended = function (options?: ClientOptions): ClientExtended {
    const baseClient = createClientOriginal({
        url: undefined,
        ...options,
        queryRoot: typeMap.Query!,
        mutationRoot: typeMap.Mutation!,
        subscriptionRoot: typeMap.Subscription!,
    }) as any

    // Оборачиваем базовый клиент для передачи параметров напрямую
    return {
        query: async (request, requestOptions) => {
            return baseClient.query(request, requestOptions)
        },
        mutation: async (request, requestOptions) => {
            return baseClient.mutation(request, requestOptions)
        },
    }
}


